import React, { useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { Form, Input, Button, message, Spin, Typography, Layout, Row, Col, Card } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';

const { Title, Text } = Typography;
const { Content } = Layout;

const Login = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const { login } = useContext(AuthContext);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const res = await api.post('/api/auth/login', values);
      const { token, user } = res.data;
      login(user, token);
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

//await registerFCMToken();
      messageApi.open({
        type: 'success',
        content: `Welcome, ${user.username}! Redirecting...`,
        duration: 2,
      });

      setTimeout(() => {
        const rolePaths = {
          admin: '/admin',
          inventorymanager: '/inventory',
          salesmanager: '/sales',
          systemadmin: '/admin',
          marketing: '/admin',
          finance: '/admin',
        };
        navigate(rolePaths[user.role] || '/');
      }, 1500);

    } catch (err) {
      console.error(err);
      messageApi.error(err.response?.data?.error || 'Invalid credentials. Please try again.');
      setLoading(false);
    }
  };

  // --- Inline Styles for a CSS-Free Design ---

  const layoutStyle = {
    minHeight: '100vh',
    // Exotic, dark gradient background
    background: 'linear-gradient(135deg, #1a1a1a 0%, #2c3e50 50%, #34495e 100%)',
    padding: '20px',
  };

  const cardStyle = {
    // "Frosted Glass" effect
    background: 'rgba(255, 255, 255, 0.1)',
    backdropFilter: 'blur(15px)',
    WebkitBackdropFilter: 'blur(15px)', // For Safari
    borderRadius: '16px',
  
    padding: '20px',
  };

  const logoStyle = {
    fontFamily: "'Montserrat', 'Helvetica', sans-serif",
    fontSize: '60px',
    fontWeight: '700',
    color: '#FFC107', // Brand Yellow
    textAlign: 'center',
    marginBottom: '10px',
    // Subtle glow effect
    textShadow: '0 0 15px rgba(255, 193, 7, 0.6)',
  };

  const titleStyle = {
    textAlign: 'center',
    color: '#FFFFFF',
    fontWeight: '600',
    marginBottom: '5px',
  };

  const textStyle = {
    textAlign: 'center',
    color: 'rgba(255, 255, 255, 0.7)',
    display: 'block',
    marginBottom: '30px',
  };

  const buttonStyle = {
    background: '#FFC107',
    borderColor: '#FFC107',
    color: '#1a1a1a',
    fontWeight: 'bold',
    height: '50px',
  };

  return (
    <Layout style={layoutStyle}>
      {contextHolder}
      <Content>
        <Row justify="center" align="middle" style={{ minHeight: 'calc(100vh - 40px)' }}>
          <Col xs={22} sm={16} md={12} lg={8} xl={7}>
            <Card style={cardStyle} bordered={false}>
              <div style={logoStyle}>JS</div>
              <Title level={3} style={titleStyle}>JS Construction Machinery Spare Parts</Title>
              <Text style={textStyle}>Sales & Inventory Portal</Text>
              
              <Spin spinning={loading} tip="Authenticating...">
                <Form
                  name="glass-login"
                  onFinish={onFinish}
                  layout="vertical"
                  size="large"
                >
                  <Form.Item
                    name="username"
                    rules={[{ required: true, message: 'Username is required' }]}
                  >
                    <Input prefix={<UserOutlined />} placeholder="Username" />
                  </Form.Item>

                  <Form.Item
                    name="password"
                    rules={[{ required: true, message: 'Password is required' }]}
                  >
                    <Input.Password prefix={<LockOutlined />} placeholder="Password" />
                  </Form.Item>

                  <Form.Item style={{ marginTop: '20px' }}>
                    <Button type="primary" htmlType="submit" style={buttonStyle} block>
                      SIGN IN
                    </Button>
                  </Form.Item>
                </Form>
              </Spin>
            </Card>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default Login;
